"use client";
import { Text as e } from "../Text/Text.mjs";
import { forwardRef as t, isValidElement as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-avatar";
//#region src/components/atoms/Avatar/Avatar.tsx
var a = t((e, t) => /* @__PURE__ */ r(i.Root, {
	"data-slot": "avatar",
	...e,
	ref: t
}));
a.displayName = "AvatarRoot";
var o = t((e, t) => /* @__PURE__ */ r(i.Image, {
	"data-slot": "avatar-image",
	...e,
	ref: t
}));
o.displayName = "AvatarImage";
var s = t(({ children: t, fontSize: a = "sm", fontWeight: o = "semibold", fontFamily: s = "inter", ...c }, l) => /* @__PURE__ */ r(i.Fallback, {
	"data-slot": "avatar-fallback",
	...c,
	ref: l,
	children: /* @__PURE__ */ r(e, {
		asChild: !0,
		fontSize: a,
		fontWeight: o,
		fontFamily: s,
		children: n(t) ? t : /* @__PURE__ */ r("span", { children: t })
	})
}));
s.displayName = "AvatarFallback";
//#endregion
export { s as AvatarFallback, o as AvatarImage, a as AvatarRoot };
